module.exports = __webpack_public_path__ + "img/After-Registering-en.8a7b1c8.png";